/**
 * form-loading.js — trạng thái "đang gửi" cho các form gửi lên server.
 *
 * Áp cho MỌI nút submit có `data-loading-label`: form Liên hệ, nút "Đặt hàng" ở trang
 * thanh toán, form tra cứu đơn. Chính thuộc tính đó vừa là công tắc bật tính năng, vừa
 * là chỗ chứa chữ ĐÃ DỊCH — file JS này được gulp build sẵn nên không đọc được bản dịch
 * của WordPress, phải để PHP truyền sang.
 *
 * Các form đều POST/GET thật (PRG qua admin-post.php hoặc WooCommerce), không phải AJAX:
 * bấm xong là điều hướng đi. Nên trạng thái này không chờ callback nào cả — nó chỉ cần
 * sống tới lúc trang mới thay thế trang hiện tại, và phải tự gỡ khi người dùng bấm Back.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var buttons = [].slice.call(document.querySelectorAll('[data-loading-label]'));
    if (!buttons.length) return;

    var restorers = [];

    buttons.forEach(function (button) {
        var form = button.form;
        if (!form) return;

        // Chỉ đổi chữ trong <span data-loading-target>, KHÔNG đụng vào cả nút: icon phải
        // còn nguyên trong DOM để lúc khôi phục không phải dựng lại HTML.
        //
        // Bản trước tìm nhãn bằng `submit.querySelector('span')` trong khi nút không có
        // <span> nào — nhãn chưa bao giờ đổi được, chỉ mỗi `disabled` chạy. Mốc neo bằng
        // data-attribute thì hỏng là hỏng ồn ào, không âm thầm như bám vào tên thẻ.
        var label = button.querySelector('[data-loading-target]');
        var idle = label ? label.textContent : '';
        var wasDisabled = false;
        var busy = false;

        function start() {
            busy = true;
            wasDisabled = button.disabled;
            button.disabled = true;
            button.classList.add('is-loading');
            button.setAttribute('aria-busy', 'true');

            if (label) label.textContent = button.getAttribute('data-loading-label');
        }

        function stop() {
            // Chưa từng bấm gửi thì không có gì để khôi phục. Bỏ điều kiện này là hỏng
            // đúng một tình huống: rời trang /send-rfq rồi bấm Back về khi form còn
            // trống — `wasDisabled` vẫn là false mặc định nên nút bị MỞ ra, đè lên phần
            // khoá-theo-tính-hợp-lệ của rfq.js.
            if (!busy) return;
            busy = false;

            // Trả về ĐÚNG trạng thái trước lúc gửi, vì lý do vừa nói.
            button.disabled = wasDisabled;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');

            if (label) label.textContent = idle;
        }

        form.addEventListener('submit', function () {
            // Hoãn một tick: đặt `disabled` NGAY trong handler thì trình duyệt loại luôn
            // name/value của nút khỏi dữ liệu gửi đi, có bản còn huỷ cả lần gửi.
            window.setTimeout(start, 0);
        });

        restorers.push(stop);
    });

    /*
     * Bấm Back: Safari và Firefox trả trang từ bfcache nguyên trạng — nút vẫn xám và vẫn
     * ghi "Sending…", người dùng tưởng form treo. `pageshow` với persisted = true là chỗ
     * duy nhất bắt được việc này; `load` và `DOMContentLoaded` không bắn lại.
     */
    window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;

        restorers.forEach(function (stop) {
            stop();
        });
    });
})();
